import { SpaceBetween, Spinner } from "@amzn/awsui-components-react";
import React from "react";
import { FullPageTitle } from "src/components/header/title";

export class Loader extends React.Component {
  render() {
    return (
      <>
        <FullPageTitle title={"Update Plan"} description={"Update Plan info"} />
        <SpaceBetween size="l">
          <Spinner size="large"></Spinner>;
        </SpaceBetween>
      </>
    );
  }
}
